import capitalize from 'lodash/capitalize';

export const isValidJSON = (value: string) => {
  try {
    JSON.parse(value);
    return true;
  } catch (error) {
    return false;
  }
};

/*
  Test if the argument str is empty, which includes newline & blank spaces.
*/
export const isEmptyString = (str: string) => !/\S/.test(str);

/*
  When toTitleCase is false:
    Input: home_inspection
    Output: Home inspection
  When toTitleCase is true:
    Input: home_inspection
    Output: Home Inspection
*/
export const getFormattedString = (str: string, toTitleCase = false) => {
  if (!str || str.length === 0) return str;
  const ret = ((str === 're_inspection' || str === 're_visit') ? capitalize(str.replace(/_/g, '-')) : capitalize(str.replace(/_/g, ' ')));
  if (!toTitleCase) return ret;
  const strSplit = ret.split(' ');
  for (let i = 0; i < strSplit.length; i += 1) {
    if (strSplit[i]) {
      strSplit[i] = strSplit[i][0].toUpperCase() + strSplit[i].substring(1);
    }
  }

  return strSplit.join(' ');
};

/*
  Example:
  Input: arr = ["home_inspection", "re_inspection", "rent_ready_inspection"]
  Output: "Home inspection, Re-inspection, Rent ready inspection"
*/
export const stringListBuilder = (arr: (string | null)[]) : string => {
  const validStrings = arr.filter((str) => str && str !== '') as string[];
  return validStrings.map((str) => (getFormattedString(str))).join(', ');
};

// From: https://stackoverflow.com/questions/64254355/cut-string-into-chunks-without-breaking-words-based-on-max-length
/*
   Input:
      n = 16
      str = 'The quick brown fox jumps over the lazy dog'
  Output: ["The quick brown", "fox jumps over", "the lazy dog"]
*/
export const splitString = (n: number, str: string) => {
  const arr = str?.split(' ');
  const result = [];
  let subStr = arr[0];
  for (let i = 1; i < arr.length; i += 1) {
    const word = arr[i];
    if (subStr.length + word.length + 1 <= n) {
      subStr = `${subStr} ${word}`;
    } else {
      result.push(subStr);
      subStr = word;
    }
  }
  if (subStr.length) { result.push(subStr); }
  return result;
};

export const getFormattedPhoneNumber = (phoneNumberString: string) => {
  const cleaned = (`${phoneNumberString}`).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return null;
};

export const isHelloInspectifyEmail = (email: string) => {
  if (email.indexOf('hello') !== -1
    && email.indexOf('@inspectify.com') !== -1) {
    return true;
  }
  return false;
};

export const formatURL = (url: string) => {
  let retURL = url;
  if (!url.startsWith('www') && !url.startsWith('https://')) {
    retURL = `https://www.${retURL}`;
  }
  if (url.startsWith('www')) {
    retURL = `https://${retURL}`;
  }
  return retURL;
};
